/* Progressive enhancement only. Shopify owns products, price, cart and checkout. */
(function () {
  'use strict';
  if (window.__icarsoftBF2026) {
    window.__icarsoftBF2026.init(document);
    return;
  }

  const instances = new Map();
  const selector = '[data-icbf2026]';
  const rootsWithin = scope => scope.matches && scope.matches(selector)
    ? [scope] : Array.from(scope.querySelectorAll(selector));

  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const timers = new Set();
    const signal = controller.signal;
    const find = id => root.querySelector('[data-icbf-id="' + id + '"]');
    const tabs = Array.from(root.querySelectorAll('.icbf-spot-tab'));
    const panels = Array.from(root.querySelectorAll('.icbf-spot-pane'));
    const filters = Array.from(root.querySelectorAll('[data-filter]'));
    const cards = Array.from(root.querySelectorAll('.icbf-card[data-group]'));
    const journeyNodes = Array.from(root.querySelectorAll('.icbf-j-node'));
    const end = Date.parse(root.dataset.endAt);
    const countdownLabel = find('cd-label');
    const countdownBoxes = root.querySelector('.icbf-cd-boxes');
    const countdownDigits = ['d', 'h', 'm', 's'].map(unit => find('cd-' + unit));
    let current = 0;
    let countdown = null;
    let expired = false;
    let activeJourney = null;

    // Native scrolling keeps every review readable without JS. Buttons add manual
    // paging only: no autoplay, network calls, clones or hidden review content.
    const reviewTrack = find('reviews-track');
    const reviewControls = find('reviews-controls');
    const reviewPrev = find('reviews-prev');
    const reviewNext = find('reviews-next');
    const reviewStatus = find('reviews-status');
    let stopReviews = () => {};
    if (reviewTrack && reviewControls && reviewPrev && reviewNext && reviewStatus) {
      const reviews = Array.from(reviewTrack.querySelectorAll('.icbf-review'));
      let frame = null;
      function reviewMetrics() {
        const step = reviews.length > 1 ? reviews[1].offsetLeft - reviews[0].offsetLeft : reviewTrack.clientWidth;
        const width = reviews[0] ? reviews[0].getBoundingClientRect().width : step;
        const perPage = Math.max(1, Math.round(reviewTrack.clientWidth / Math.max(1, width)));
        const max = Math.max(0, reviewTrack.scrollWidth - reviewTrack.clientWidth);
        const first = Math.min(Math.max(0, reviews.length - perPage), Math.max(0, Math.round(reviewTrack.scrollLeft / Math.max(1, step))));
        return { step, perPage, max, first };
      }
      function syncReviews() {
        frame = null;
        const { max, first, perPage } = reviewMetrics();
        const canScroll = max > 4;
        reviewControls.hidden = !canScroll;
        reviewTrack.classList.toggle('has-review-controls', canScroll);
        reviewPrev.disabled = reviewTrack.scrollLeft <= 4;
        reviewNext.disabled = reviewTrack.scrollLeft >= max - 4;
        const last = Math.min(reviews.length, first + perPage);
        const range = perPage === 1 ? String(first + 1) : (first + 1) + '–' + last;
        const label = range + ' of ' + reviews.length + ' reviews';
        if (reviewStatus.textContent !== label) reviewStatus.textContent = label;
      }
      function queueReviewSync() {
        if (frame === null) frame = window.requestAnimationFrame(syncReviews);
      }
      function moveReviews(direction) {
        const { step, perPage, max, first } = reviewMetrics();
        const target = direction === 'start' ? 0 : direction === 'end' ? max : (first + direction * perPage) * step;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || root.classList.contains('is-motion-paused');
        reviewTrack.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: reduce ? 'instant' : 'smooth' });
      }
      reviewPrev.addEventListener('click', () => moveReviews(-1), { signal });
      reviewNext.addEventListener('click', () => moveReviews(1), { signal });
      reviewTrack.addEventListener('scroll', queueReviewSync, { signal, passive: true });
      reviewTrack.addEventListener('keydown', event => {
        // Links retain their usual keyboard behavior; the track itself can be paged.
        if (event.target !== reviewTrack) return;
        const moves = { ArrowLeft: -1, ArrowRight: 1, Home: 'start', End: 'end' };
        if (!Object.prototype.hasOwnProperty.call(moves, event.key)) return;
        event.preventDefault();
        moveReviews(moves[event.key]);
      }, { signal });
      const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(queueReviewSync) : null;
      if (observer) observer.observe(reviewTrack);
      else window.addEventListener('resize', queueReviewSync, { signal, passive: true });
      syncReviews();
      stopReviews = () => {
        if (observer) observer.disconnect();
        if (frame !== null) window.cancelAnimationFrame(frame);
        reviewControls.hidden = true;
        reviewTrack.classList.remove('has-review-controls');
      };
    }

    // Keep the last explored step lit; pointer exit never clears the selection.
    function selectJourney(node) {
      if (activeJourney === node) return;
      journeyNodes.forEach(item => item.classList.toggle('is-journey-active', item === node));
      activeJourney = node;
    }
    journeyNodes.forEach(node => {
      node.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') selectJourney(node);
      }, { signal, passive: true });
      node.addEventListener('click', () => selectJourney(node), { signal });
      node.addEventListener('focus', () => selectJourney(node), { signal });
    });

    function selectSpot(index, focus) {
      if (!tabs.length) return;
      current = (index + tabs.length) % tabs.length;
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === current));
        tab.tabIndex = i === current ? 0 : -1;
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.panel !== tabs[current].dataset.spot;
      });
      if (focus) tabs[current].focus();
      if (typeof root.dispatchEvent === 'function') {
        root.dispatchEvent(new CustomEvent('icarsoft:bf2026:spotchange', {
          detail: { panel: panels.find(panel => !panel.hidden) }
        }));
      }
    }

    function expire() {
      if (expired) return;
      expired = true;
      root.querySelectorAll('[data-active-offer]').forEach(el => { el.hidden = true; });
      const replacements = [
        ['[data-event-eyebrow]', 'Early Bird · Event ended'],
        ['[data-event-headline]', 'Explore the Tools'],
        ['[data-event-intro]', 'The Early Bird event has ended. Explore current tools and prices below.'],
        ['[data-event-closing]', 'Explore the tools. Find your next tool.'],
        ['[data-event-closing-kicker]', 'Explore the collection'],
        ['[data-event-summary]', 'Browse current product prices and availability.']
      ];
      replacements.forEach(([query, text]) => {
        const element = root.querySelector(query);
        if (element) element.textContent = text;
      });
      if (countdown) window.clearInterval(countdown);
      countdown = null;
    }

    function tick() {
      if (!Number.isFinite(end)) {
        if (countdownLabel) countdownLabel.textContent = 'See event dates below';
        if (countdownBoxes) countdownBoxes.hidden = true;
        return;
      }
      const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
      countdownDigits.forEach((element, i) => {
        const value = String(values[i]).padStart(2, '0');
        if (element && element.textContent !== value) element.textContent = value;
      });
      if (seconds <= 0) {
        if (countdownLabel) countdownLabel.textContent = 'Early Bird has ended';
        expire();
      }
    }

    function syncCountdown() {
      window.clearInterval(countdown);
      countdown = null;
      if (document.hidden) return;
      tick();
      if (Number.isFinite(end) && end > Date.now()) countdown = window.setInterval(tick, 1000);
    }

    async function copyCode(button) {
      const code = button.dataset.copy;
      if (!code) return;
      const label = button.dataset.copyLabel || button.textContent;
      button.dataset.copyLabel = label;
      let copied = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        } else {
          const field = document.createElement('textarea');
          field.value = code;
          field.setAttribute('readonly', '');
          field.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;';
          root.appendChild(field);
          field.select();
          copied = document.execCommand('copy');
          field.remove();
          button.focus();
        }
      } catch (_) {
        copied = false;
      }
      if (signal.aborted) return;
      button.textContent = copied ? 'Copied ✓' : 'Select code';
      button.classList.toggle('icbf-done', copied);
      if (!copied) {
        const text = button.closest('.icbf-codechip').querySelector('.icbf-code');
        if (text && window.getSelection) {
          const range = document.createRange();
          range.selectNodeContents(text);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      const timer = window.setTimeout(() => {
        button.textContent = label;
        button.classList.remove('icbf-done');
        timers.delete(timer);
      }, 2000);
      timers.add(timer);
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.hasAttribute('data-copy')) copyCode(button);
      if (button.matches('.icbf-spot-tab')) selectSpot(tabs.indexOf(button), false);
      if (button === find('spot-prev')) selectSpot(current - 1, false);
      if (button === find('spot-next')) selectSpot(current + 1, false);
      if (button.hasAttribute('data-filter')) {
        const filter = button.dataset.filter;
        let count = 0;
        filters.forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
        cards.forEach(card => {
          card.hidden = filter !== 'all' && card.dataset.group !== filter;
          if (!card.hidden) count++;
        });
        const status = root.querySelector('[data-filter-status]');
        if (status) status.textContent = count ? count + (count === 1 ? ' tool shown' : ' tools shown') : 'No tools currently available in this category.';
      }
    }, { signal });

    root.addEventListener('keydown', event => {
      const tab = event.target.closest('.icbf-spot-tab');
      if (!tab) return;
      const moves = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: tabs.length - 1 };
      if (Object.prototype.hasOwnProperty.call(moves, event.key)) {
        event.preventDefault();
        selectSpot(moves[event.key], true);
      }
    }, { signal });

    instances.set(root, () => {
      controller.abort();
      stopReviews();
      window.clearInterval(countdown);
      timers.forEach(timer => window.clearTimeout(timer));
      panels.forEach(panel => { panel.hidden = false; });
      cards.forEach(card => { card.hidden = false; });
      journeyNodes.forEach(node => node.classList.remove('is-journey-active'));
      root.classList.remove('is-enhanced');
      instances.delete(root);
    });
    selectSpot(0, false);
    root.classList.add('is-enhanced');
    document.addEventListener('visibilitychange', syncCountdown, { signal });
    syncCountdown();
  }

  function init(scope) { rootsWithin(scope).forEach(mount); }
  window.__icarsoftBF2026 = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsWithin(event.target).forEach(root => {
      const cleanup = instances.get(root);
      if (cleanup) cleanup();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
